// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"187":"cddc047cf8ea6f4de358","189":"a9924ce371770634f100","421":"e81369c647cc686c0209"}[chunkId] + ".css";
};